/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classnames from 'classnames';
import qDocPromise from 'config/qDoc';
import styles from './styles';

class Filter extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    sortBy: PropTypes.string,
    title: PropTypes.string.isRequired,
    toggleSelections: PropTypes.bool,
    dropdown: PropTypes.bool,
    overrideLock: PropTypes.bool,
    titleShow: PropTypes.bool,
    headerShow: PropTypes.bool,
    selectType: PropTypes.string,
    onChange: PropTypes.func,

  };

  static defaultProps = {
    toggleSelections: false,
    dropdown: false,
    overrideLock: false,
    sortBy: null,
    titleShow: true,
    headerShow: true,
    selectType: 'multi',
    onChange: () => {}
  };

  state = {
    qMatrix: [],
    dropdownOpen: false,
  };

  componentDidMount() {
    this.createQObject();
    document.addEventListener('click', this.handleOutsideClick);
  }

  componentWillUnmount() {
    this.destroyQObject();
    document.removeEventListener('click', this.handleOutsideClick);
  }

  createQObject = async () => {
    const qDoc = await qDocPromise;
    this.qObject = await qDoc.createSessionObject({
      qInfo: { qType: 'list' },
      qListObjectDef: {
        qDef: {
          qFieldDefs: [this.props.field],
          qSortCriterias: this.props.sortBy
            ? [
              {
                qSortByState: 0,
                qSortByExpression: 1,
                qExpression: this.props.sortBy,
                qSortByGreyness: 0,
              },
            ]
            : [],
        },
        qInitialDataFetch: [
          {
            qWidth: 1,
            qHeight: 1000,
          },
        ],
      },
    });
    this.qObject.on('changed', this.updateQMatrix);
    this.updateQMatrix();
  };

  destroyQObject = async () => {
    const qDoc = await qDocPromise;
    qDoc.destroySessionObject(this.qObject.id);
  };

  updateQMatrix = async () => {
    const layout = await this.qObject.getLayout();
    this.setState({ qMatrix: layout.qListObject.qDataPages[0].qMatrix });
  };

  handleDropdownClick = (e) => {
    e.stopPropagation(); // Prevent the event from propagating to the document
    this.setState(prevState => ({ dropdownOpen: !prevState.dropdownOpen }));
  };

  handleOutsideClick = () => {
    if (this.state.dropdownOpen) {
      this.setState({ dropdownOpen: false });
    }
  };

  handleSelection = (row) => async () => {
    const { selectType, onChange } = this.props;
   if (selectType === 'single' && row.qState !== 'S') {
      // Clear previous selections and select the new one
      this.qObject.selectListObjectValues(
        '/qListObjectDef',
        [row.qElemNumber],
        false, // Clear previous selections
        this.props.overrideLock,
      );
    } else if (selectType === 'single' && row.qState == 'S') {
      // Clear previous selections and select the new one
      this.qObject.selectListObjectValues(
        '/qListObjectDef',
        [row.qElemNumber],
        this.props.toggleSelections,
        this.props.overrideLock,
      );
    }  else if (selectType === 'multi') {
      // Allow multiple selections
      this.qObject.selectListObjectValues(
        '/qListObjectDef',
        [row.qElemNumber],
        this.props.toggleSelections,
        this.props.overrideLock,
      );
    }

    // If an onChange prop is provided, call it with the selected value
    if (onChange) {
      onChange(row.qText);
    }

    this.setState({ dropdownOpen: false });
  };

  render() {
    const { classes, title, dropdown, titleShow, headerShow, selectType } = this.props;
    const { qMatrix, dropdownOpen } = this.state;

    const singleSelected = selectType === 'single' && qMatrix.some(row => row[0].qState === 'S');

    return (
      <div className={classes.root} onClick={e => e.stopPropagation()}>
         {
          headerShow && 
            <div className={classes.title}>
              {title}
              {titleShow &&<span className={classes.subTitle}>{selectType} Select</span>}
            </div>
          
         }
        
        {dropdown && (
          <div className="lui-select" onClick={this.handleDropdownClick}>
            {qMatrix.find(row => row[0].qState === 'S' || row[0].qState === 'L') &&
              qMatrix.find(row => row[0].qState === 'S' || row[0].qState === 'L')[0].qText}
          </div>
        )}
        <ul
          className={classes.ul}
          style={{
            display: !dropdown || dropdownOpen ? 'block' : 'none',
            border: dropdown ? '1px solid #b8b8b8' : 'none',
            maxHeight: dropdown ? '200px' : 'auto',
            width: dropdown ? '208px' : 'auto',
            position: dropdown ? 'absolute' : 'static',
            background: 'white',
            overflowY: 'auto',
            overflowX: 'auto',
          }}
        >
          {qMatrix.map((row) => {
            const liClass = classnames(
              classes.li,
              (!dropdown &&
                (row[0].qState === 'S' || row[0].qState === 'L')) &&
                classes.selected,
              (!dropdown && row[0].qState) === 'X' && classes.excluded,
            );
            return (
              <li
                key={row[0].qElemNumber}
                onClick={this.handleSelection(row[0])}
                className={liClass}
                style={{
                  margin: dropdown ? '5px 0' : '',
                }}
                // style={{
                //   margin: dropdown ? '5px 0' : '',
                //   cursor:
                //     selectType === 'single' &&
                //     row[0].qState !== 'S' &&
                //     this.state.qMatrix.some(r => r[0].qState === 'S') // If another value is selected, disable cursor
                //       ? 'not-allowed'
                //       : 'pointer',
                //   opacity:
                //     selectType === 'single' &&
                //     row[0].qState !== 'S' &&
                //     this.state.qMatrix.some(r => r[0].qState === 'S') // Dim other options when one is selected
                //       ? 0.6
                //       : 1,
                // }}
              
              >
                {row[0].qText}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

export default injectSheet(styles)(Filter);
